import { css } from '@emotion/react'
import ChevronUp from 'assets/icons/chevron-up.svg'
import { styled } from 'styles/styled'
import { theme } from 'styles/theme'

interface Level1CategoriesButtonProps {
  $isSelected?: boolean
}
export const Level1CategoriesButton = styled.div<Level1CategoriesButtonProps>`
  padding: 0 20px;
  background-color: white;
  border: 1px solid ${theme.palette.surface.secondary};
  height: 50px;
  box-sizing: content-box;
  cursor: pointer;
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      border-bottom: none;
    `};
`

export const StyledChevronDown = styled(ChevronUp)`
  transform: rotate(180deg);
`

export const StyledChevronUp = styled(ChevronUp)``
